export default {
    acc: 'https://acc.dev.mrbilit.ir',
    auth: 'https://auth.dev.mrbilit.ir',
    bill: 'https://bill.dev.mrbilit.ir',
    bus: 'https://bus.dev.mrbilit.ir',
    content: 'https://content.mrbilit.ir',
    coupon: 'https://coupon.dev.mrbilit.ir',
    faas: 'https://fn.mrbilit.com',
    finalize: 'https://finalize.dev.mrbilit.ir/api',
    flight: 'https://flight.dev.mrbilit.com',
    giftCard: 'https://giftcard.dev.mrbilit.ir/',
    hotel: 'https://hotel.dev.mrbilit.ir',
    notifier: 'https://notifier.dev.mrbilit.ir',
    panel: 'https://panel.dev.mrbilit.com',
    payment: 'https://payment.dev.mrbilit.com',
    priceTrack: 'https://pricetrack.dev.mrbilit.ir',
    tracking: 'https://errortracking.mrbilit.net',
    train: 'https://train.dev.mrbilit.ir',
    flightInfo: 'https://flightinfo.mrbilit.ir',
    userLog: 'https://user-log.mrbilit.ir',
    workflow: 'https://workflow.dev.mrbilit.ir',
    support: 'https://support.dev.mrbilit.com',
    multiRoute: 'https://masir.dev.mrbilit.com/',
};
